// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-pagination{display:flex;align-items:center;justify-content:flex-end;padding:10px}.admin-pagination li .MuiPaginationItem-root{width:21px;height:21px;font-size:12px;font-family:\"HelveticaNeueCyr-Light\",\"Helvetica\",sans-serif;min-width:unset;color:#6699CC}.admin-pagination li .Mui-selected{color:white;background:#6699CC}\n", ""]);
// Exports
module.exports = exports;
